export default __webpack_public_path__ + "static/media/tool-icon-horde-low.49fd61ee.svg";